import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { Toaster } from "./components/ui/sonner";
import ScrollToHashWrapper from "./components/ScrollToHashWrapper";

// Lazy-loaded Pages (code-split per route)
const Home = lazy(() => import("./pages/Home"));
const WhoWeAre = lazy(() => import("./pages/WhoWeAre"));
const OurWork = lazy(() => import("./pages/OurWork"));
const MealPackaging = lazy(() => import("./pages/MealPackaging"));
const JoinTheMovement = lazy(() => import("./pages/JoinTheMovement"));
const StoriesMedia = lazy(() => import("./pages/StoriesMedia"));
const Blog = lazy(() => import("./pages/Blog"));
const Contact = lazy(() => import("./pages/Contact"));
const Donate = lazy(() => import("./pages/Donate"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const DonorTerms = lazy(() => import("./pages/DonorTerms"));
const RefundPolicy = lazy(() => import("./pages/RefundPolicy"));
const Admin = lazy(() => import("./pages/Admin"));
const Careers = lazy(() => import("./pages/Careers"));
const GiftAMeal = lazy(() => import("./pages/GiftAMeal"));
const Quiz = lazy(() => import("./pages/Quiz"));
const HungerActionPledge = lazy(() => import("./pages/HungerActionPledge"));

// Pillar Pages
const NourishingLives = lazy(() => import("./pages/pillars/NourishingLives"));
const CommunityEmpowerment = lazy(() => import("./pages/pillars/CommunityEmpowerment"));
const EmergencyResponse = lazy(() => import("./pages/pillars/EmergencyResponse"));
const GrowingTheMovement = lazy(() => import("./pages/pillars/GrowingTheMovement"));

// Minimal loading spinner for Suspense fallback
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="w-10 h-10 border-4 border-orange-200 border-t-orange-600 rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHashWrapper />
        <Navbar />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/our-work" element={<OurWork />} />
            <Route path="/meal-packaging" element={<MealPackaging />} />
            <Route path="/join-the-movement" element={<JoinTheMovement />} />
            <Route path="/stories-media" element={<StoriesMedia />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/gift-a-meal" element={<GiftAMeal />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/hunger-action-pledge" element={<HungerActionPledge />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/donor-terms" element={<DonorTerms />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/:slug" element={<Careers />} />
            
            {/* Pillar Pages */}
            <Route path="/pillars/nourishing-lives" element={<NourishingLives />} />
            <Route path="/pillars/community-empowerment" element={<CommunityEmpowerment />} />
            <Route path="/pillars/emergency-response" element={<EmergencyResponse />} />
            <Route path="/pillars/growing-the-movement" element={<GrowingTheMovement />} />
          </Routes>
        </Suspense>
        <Footer />
        <BackToTop />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
